
import Loadable from 'react-loadable';
import Spinner from '../../components/panel-loading';


export default Loadable({
  loader: () => import(/* webpackChunkName: "ItemAll"*/'./item-all'),
  loading: Spinner,
});
